module.exports = __webpack_public_path__ + "static/media/star_full.7a27fa64.png";